<template>
    <div class="page-wrapper" id="scroll_top">
        <section
            class="hero"
            v-if="pageIsLoaded"
            :style="'background-image:url(' + content.hero.image.url + ');'"
        >
            <div class="data" data-inview="fadeInUp" data-delay="200">
                <a :href="content.hero.video" class="glightbox play"
                    >
                    <svg fill="#ffb81c" width="64px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 459 459" xml:space="preserve">
                    <g>
                        <g>
                            <path d="M229.5,0C102.751,0,0,102.751,0,229.5S102.751,459,229.5,459S459,356.249,459,229.5S356.249,0,229.5,0z M310.292,239.651
                                l-111.764,76.084c-3.761,2.56-8.63,2.831-12.652,0.704c-4.022-2.128-6.538-6.305-6.538-10.855V153.416
                                c0-4.55,2.516-8.727,6.538-10.855c4.022-2.127,8.891-1.857,12.652,0.704l111.764,76.084c3.359,2.287,5.37,6.087,5.37,10.151
                                C315.662,233.564,313.652,237.364,310.292,239.651z"/>
                        </g>
                    </g>
                    </svg>
               </a>
                <h1 class="title">
                    <span
                        v-html="content.hero.titre.replace('p>', 'span>').replace('/p>', '/span>')"
                    ></span>
                </h1>
            </div>
            <a href="#expertise" v-scroll-to:-120
                ><img src="@/assets/img/arrow-down.svg" alt="Icon Arrow down" class="arrow"
            /></a>
            <div class="overlay"></div>
            <div class="hero-video">
                <video
                    ref="videoRef"
                    data-src="/static/img/hero-video-bg-optim2.mp4"
                    playsinline=""
                    autoplay="autoplay"
                    muted="muted"
                    loop="loop"
                    :poster="content.hero.image.url"
                    class="video"
                    type="video/mp4"
                    ></video>
            </div>
        </section>

        <section class="expertise_home" id="expertise" v-if="pageIsLoaded">
            <div class="title_wrap" data-inview="fadeInUp" data-delay="200">
                <div class="left">
                    <h2 class="title small">{{ content.entete1.surtitre }}</h2>
                    <h3 class="title medium"><span v-html="content.entete1.titre"></span></h3>
                </div>
                <div class="right">
                    <p class="regular-text">
                        <span v-html="content.entete1.texte"></span>
                    </p>
                </div>
            </div>

            <a
                :href="globals.servicesEntry.data[0].page.jsonUrl"
                class="bloc"
                data-inview="fadeInUp"
                data-delay="200"
            >
                <div class="img">
                    <div class="more">
                        <p class="regular-text">{{ $t('En savoir plus') }}</p>
                    </div>
                    <img :src="globals.servicesEntry.data[0].page.imageSimple1.url" alt="Bâtiment" loading="lazy" width="531" height="560" />
                </div>
                <div class="data">
                    <h3 class="title">{{ globals.servicesEntry.data[0].page.titre }}</h3>
                    <p class="regular-text">
                        <span v-html="globals.servicesEntry.data[0].page.texteSimple1"></span>
                    </p>
                    <svg
                        class="number"
                        viewBox="0 0 76 67"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M15.2916 53.488L15.2914 53.4881L15.3003 53.4973C16.3815 54.6171 17.7432 55.4222 19.24 55.8309V66.3757C13.9041 65.8744 9.61835 64.0435 6.34586 60.9089L6.34564 60.9087C2.46289 57.1942 0.5 52.125 0.5 45.64V21C0.5 14.6447 2.46091 9.6518 6.34438 5.96251L6.34478 5.96212C9.61712 2.84651 13.9032 1.03126 19.24 0.543016V11.0966C17.7409 11.4967 16.3771 12.3005 15.2993 13.4238L15.2992 13.4237L15.2916 13.432C14.4005 14.4035 13.711 15.542 13.2628 16.7816C12.816 18.0175 12.618 19.3294 12.6801 20.6419V46.2781C12.618 47.5906 12.816 48.9025 13.2628 50.1383C13.711 51.378 14.4005 52.5165 15.2916 53.488Z"
                        />
                        <path
                            d="M29.2791 13.4324L29.2737 13.4265L29.2681 13.4208C28.1611 12.2865 26.7681 11.4769 25.2402 11.0752V0.542389C30.5776 1.02458 34.8777 2.83996 38.1763 5.96291C42.0595 9.65216 44.0203 14.645 44.0203 21V45.64C44.0203 52.1248 42.0575 57.1938 38.1751 60.9083C34.8763 64.0565 30.5766 65.8878 25.2402 66.3769V55.8458C26.7702 55.4475 28.1646 54.6366 29.2691 53.4982L29.2742 53.4929L29.2791 53.4876C30.1688 52.5156 30.8568 51.3767 31.3032 50.1369C31.7482 48.9011 31.9442 47.5895 31.8802 46.2777V20.6423C31.9442 19.3305 31.7482 18.0189 31.3032 16.7831C30.8568 15.5433 30.1688 14.4044 29.2791 13.4324Z"
                        />
                        <path
                            d="M74.5899 1.16005V1.16012L74.5983 1.15998C74.6776 1.15865 74.7562 1.17328 74.8297 1.20304C74.9031 1.2328 74.9699 1.27706 75.0258 1.33317L75.3798 0.980028L75.0312 1.33851C75.089 1.39469 75.1347 1.46208 75.1654 1.53654C75.1962 1.61115 75.2113 1.69116 75.2099 1.77156L75.2099 1.77156V1.78005L75.2098 64.81L75.21 64.8205C75.2117 64.9004 75.1968 64.9798 75.1662 65.0539C75.1357 65.1278 75.0903 65.1947 75.0327 65.2502L75.0223 65.2602L75.0125 65.2708C74.9625 65.325 74.9012 65.3673 74.833 65.395C74.7647 65.4226 74.6912 65.4349 74.6176 65.4308L74.6037 65.43H74.5899H63.6698H63.6626L63.6554 65.4302C63.5779 65.4325 63.5008 65.4186 63.429 65.3895C63.357 65.3604 63.292 65.3167 63.238 65.2612L63.2325 65.2556L63.2269 65.2502C63.1695 65.1948 63.1241 65.128 63.0935 65.0539C63.0629 64.9798 63.0481 64.9004 63.0497 64.8205H63.0498V64.81V13.6701V13.6546L63.0489 13.6391C63.0327 13.3775 62.9183 13.1324 62.7298 12.952C62.6187 12.8291 62.4726 12.7422 62.3103 12.7038C62.1499 12.6658 61.9822 12.6772 61.829 12.7356L52.6249 15.2459L52.326 15.3185C52.1822 15.3102 52.1429 15.2691 52.1299 15.2539C52.1012 15.2204 52.0398 15.1114 52.0398 14.82V14.8113L52.0395 14.8025L51.7595 6.80253L51.7596 6.80253L51.7591 6.79267C51.7495 6.61873 51.795 6.4461 51.8892 6.29927C51.9833 6.15251 52.1212 6.0391 52.2834 5.97515L52.2975 5.96959L52.3112 5.96318L62.1111 1.3932L62.1112 1.39334L62.1222 1.38786C62.4768 1.21176 62.8717 1.13278 63.2668 1.15896L63.2833 1.16005H63.2998H74.5899Z"
                        />
                    </svg>
                </div>
            </a>
            <a
                :href="globals.servicesEntry.data[1].page.jsonUrl"
                class="bloc switch"
                data-inview="fadeInUp"
                data-delay="300"
            >
                <div class="img">
                    <div class="more">
                        <p class="regular-text">{{ $t('En savoir plus') }}</p>
                    </div>
                    <img :src="globals.servicesEntry.data[1].page.imageSimple1.url" alt="Bâtiment" loading="lazy" width="531" height="560" />
                </div>
                <div class="data">
                    <svg
                        class="number"
                        viewBox="0 0 99 67"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M15.2916 53.488L15.2914 53.4881L15.3003 53.4973C16.3815 54.6171 17.7432 55.4222 19.24 55.8309V66.3757C13.9041 65.8745 9.61835 64.0435 6.34586 60.9089L6.34564 60.9087C2.46289 57.1942 0.5 52.1251 0.5 45.64V21C0.5 14.6448 2.46091 9.65183 6.34438 5.96254L6.34478 5.96215C9.61712 2.84654 13.9032 1.03127 19.24 0.543016V11.0966C17.7409 11.4968 16.3771 12.3005 15.2993 13.4238L15.2992 13.4237L15.2916 13.432C14.4005 14.4035 13.711 15.542 13.2628 16.7817C12.816 18.0175 12.618 19.3294 12.6801 20.642V46.2781C12.618 47.5906 12.816 48.9025 13.2628 50.1384C13.711 51.3781 14.4005 52.5166 15.2916 53.488Z"
                        />
                        <path
                            d="M31.5691 13.4324L31.5637 13.4265L31.5581 13.4208C30.4512 12.2866 29.0582 11.477 27.5303 11.0753V0.542389C32.8677 1.02458 37.1677 2.83999 40.4663 5.96294C44.3495 9.65219 46.3103 14.645 46.3103 21V45.64C46.3103 52.1248 44.3476 57.1939 40.4651 60.9083C37.1663 64.0566 32.8667 65.8878 27.5303 66.377V55.8459C29.0603 55.4475 30.4547 54.6366 31.5592 53.4982L31.5642 53.493L31.5691 53.4876C32.4588 52.5156 33.1468 51.3767 33.5932 50.1369C34.0382 48.9011 34.2343 47.5895 34.1703 46.2777V20.6423C34.2343 19.3305 34.0382 18.019 33.5932 16.7831C33.1468 15.5433 32.4588 14.4044 31.5691 13.4324Z"
                        />
                        <path
                            d="M97.9176 55.431L97.9266 55.4405L97.936 55.4494C97.9976 55.5079 98.0454 55.5794 98.0758 55.6586C98.1061 55.7377 98.1185 55.8227 98.1118 55.9075L98.1102 55.9271V55.9468L98.1101 64.9468L98.1103 64.9573C98.112 65.0374 98.0971 65.1169 98.0667 65.1906C98.0362 65.2645 97.9908 65.3313 97.9332 65.3869L97.9228 65.3969L97.913 65.4076C97.863 65.4617 97.8016 65.5041 97.7333 65.5318C97.6651 65.5594 97.5915 65.5716 97.5179 65.5676L97.5041 65.5668H97.4902H55.4902V65.5666L55.4763 65.567C55.396 65.5692 55.3161 65.5551 55.2416 65.5254C55.1671 65.4958 55.0994 65.4512 55.0426 65.3945C54.986 65.3378 54.9414 65.2701 54.9117 65.1954C54.882 65.1207 54.8678 65.0408 54.87 64.9608L54.8702 64.9608V64.9468V56.3668V56.3582L54.8699 56.3496C54.8634 56.1596 54.8965 55.9702 54.9672 55.7936C55.0378 55.617 55.1444 55.457 55.2803 55.3239L55.2811 55.3231C58.3152 52.3358 61.4317 49.0789 64.6306 45.5528C67.8247 42.0319 69.8223 39.8413 70.6262 38.9775L70.6345 38.9686L70.6422 38.9594C72.3746 36.9084 74.1471 34.9568 75.9396 33.1045L75.9459 33.098L75.9519 33.0913C78.7928 29.9359 80.9378 27.1716 82.3753 24.8011C83.8034 22.4462 84.5682 20.4241 84.5703 18.7637C84.5989 17.6819 84.3905 16.607 83.9598 15.6143C83.5281 14.6195 82.8836 13.7313 82.0717 13.0125L82.0608 13.0028L82.0494 12.9938C80.2322 11.5644 77.9873 10.7873 75.6753 10.7873C73.3633 10.7873 71.1183 11.5644 69.3011 12.9938L69.2875 13.0045L69.2747 13.0161C68.4478 13.7644 67.7958 14.6855 67.3648 15.714C66.9351 16.7393 66.7356 17.8463 66.7803 18.957V21.2743C66.7783 21.4398 66.7113 21.5978 66.5938 21.7143C66.4759 21.8312 66.3165 21.8968 66.1503 21.8968H55.1528C54.9883 21.8949 54.8311 21.8287 54.7148 21.7123C54.5984 21.596 54.5322 21.4388 54.5303 21.2743V16.8576C54.6656 13.7397 55.7389 10.7352 57.6099 8.23731C59.5426 5.67677 62.1296 3.68444 65.0989 2.46986C68.454 1.10743 72.0505 0.43959 75.671 0.50671L75.6814 0.506903L75.6919 0.506662C79.597 0.416334 83.4686 1.24567 86.994 2.92763C89.9968 4.37594 92.5418 6.6246 94.349 9.42612C96.0645 12.1317 96.961 15.2758 96.9303 18.4793C96.8739 21.1862 96.2087 23.8458 94.9843 26.2607L94.9838 26.2618C93.4006 29.4028 91.4487 32.3438 89.1695 35.0228L89.1635 35.0299L89.1578 35.0371C87.2478 37.4577 85.1747 39.8427 82.9382 42.1921C80.6948 44.5485 77.3645 47.9656 72.9456 52.4444C72.9452 52.4448 72.9448 52.4452 72.9444 52.4457L71.5467 53.8432L71.5148 53.8751L71.4892 53.9122C71.4459 53.9747 71.3653 54.0916 71.32 54.2304C71.2671 54.3923 71.2564 54.6016 71.3722 54.8078C71.4546 54.961 71.5816 55.0858 71.7367 55.1654C71.8823 55.2402 72.0459 55.2717 72.2081 55.2568H97.4902V55.2569L97.5002 55.2567C97.578 55.2551 97.6554 55.2698 97.7273 55.2999C97.7992 55.3299 97.8641 55.3746 97.9176 55.431Z"
                        />
                    </svg>
                    <h3 class="title">{{ globals.servicesEntry.data[1].page.titre }}</h3>
                    <p class="regular-text">
                        <span v-html="globals.servicesEntry.data[1].page.texteSimple1"></span>
                    </p>
                </div>
            </a>
            <a
                :href="globals.servicesEntry.data[2].page.jsonUrl"
                class="bloc"
                data-inview="fadeInUp"
                data-delay="400"
            >
                <div class="img">
                    <div class="more">
                        <p class="regular-text">{{ $t('En savoir plus') }}</p>
                    </div>
                    <img :src="globals.servicesEntry.data[2].page.imageSimple1.url" alt="Bâtiment" loading="lazy" width="531" height="560" />
                </div>
                <div class="data">
                    <h3 class="title">{{ globals.servicesEntry.data[2].page.titre }}</h3>
                    <p class="regular-text">
                        <span v-html="globals.servicesEntry.data[2].page.texteSimple1"></span>
                    </p>
                    <svg
                        class="number"
                        viewBox="0 0 96 68"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M15.2916 53.488L15.2914 53.4881L15.3003 53.4973C16.3815 54.6171 17.7432 55.4222 19.24 55.8309V66.3757C13.9041 65.8745 9.61835 64.0435 6.34586 60.9089L6.34564 60.9087C2.46289 57.1942 0.5 52.1251 0.5 45.64V21C0.5 14.6448 2.46091 9.65183 6.34438 5.96254L6.34478 5.96215C9.61712 2.84654 13.9032 1.03127 19.24 0.543016V11.0966C17.7409 11.4968 16.3771 12.3005 15.2993 13.4238L15.2992 13.4237L15.2916 13.432C14.4005 14.4035 13.711 15.542 13.2628 16.7817C12.816 18.0175 12.618 19.3294 12.6801 20.642V46.2781C12.618 47.5906 12.816 48.9025 13.2628 50.1384C13.711 51.3781 14.4005 52.5166 15.2916 53.488Z"
                        />
                        <path
                            d="M30.5691 13.4324L30.5637 13.4265L30.5581 13.4208C29.4512 12.2866 28.0582 11.477 26.5303 11.0753V0.542389C31.8677 1.02458 36.1677 2.83999 39.4663 5.96294C43.3495 9.65219 45.3103 14.645 45.3103 21V45.64C45.3103 52.1248 43.3476 57.1939 39.4651 60.9083C36.1663 64.0566 31.8667 65.8878 26.5303 66.377V55.8459C28.0603 55.4475 29.4547 54.6366 30.5592 53.4982L30.5642 53.493L30.5691 53.4876C31.4588 52.5156 32.1468 51.3767 32.5932 50.1369C33.0382 48.9011 33.2343 47.5895 33.1703 46.2777V20.6423C33.2343 19.3305 33.0382 18.019 32.5932 16.7831C32.1468 15.5433 31.4588 14.4044 30.5691 13.4324Z"
                        />
                        <path
                            d="M80.9472 25.4424L80.9491 25.4524L80.9514 25.4625C81.0077 25.7065 81.1756 25.867 81.3621 25.9503C81.5073 26.0151 81.6646 26.0355 81.8056 26.0393C87.0237 27.0872 90.7358 30.1702 92.9685 35.3458C94.2529 38.4077 94.8896 41.7023 94.8386 45.0223L94.8385 45.0223L94.8386 45.0349C94.8692 48.16 94.3104 51.2629 93.1917 54.181L93.1916 54.181L93.1885 54.1895C91.8272 57.941 89.2576 61.1338 85.884 63.2658C82.2261 65.5159 77.9942 66.6568 73.701 66.5502L73.6894 66.5499L73.6779 66.5501C69.3627 66.6422 65.1197 65.4333 61.501 63.0808L61.5009 63.0808C58.0611 60.8455 55.431 57.5637 53.9986 53.7196C53.1256 51.2457 52.6332 48.6536 52.5382 46.0319L52.5374 46.0088L52.5344 45.9859C52.5246 45.91 52.5323 45.8329 52.557 45.7605C52.5816 45.6882 52.6226 45.6224 52.6768 45.5682C52.7309 45.5141 52.7966 45.4731 52.869 45.4485C52.9414 45.4238 53.0185 45.4161 53.0944 45.4259L53.1263 45.43H53.1585H64.1585H64.1907L64.2227 45.4259C64.2986 45.4161 64.3757 45.4238 64.4481 45.4485C64.5204 45.4731 64.5862 45.5141 64.6403 45.5682C64.6945 45.6224 64.7354 45.6882 64.7601 45.7605C64.7847 45.8329 64.7925 45.91 64.7827 45.9859L64.776 46.0374L64.7801 46.0892C64.9064 47.6963 65.2514 49.2787 65.8055 50.7925C66.3267 52.4129 67.3541 53.8233 68.7369 54.8162L68.7369 54.8162L68.7442 54.8213C70.1507 55.7938 71.8282 56.2974 73.5374 56.2604C75.1654 56.3679 76.7856 55.954 78.1628 55.0786C79.5433 54.2012 80.6074 52.9059 81.2005 51.3817C82.1354 49.2644 82.5956 46.968 82.5487 44.654C82.6403 42.1133 82.1464 39.5855 81.1051 37.2661C80.4529 35.7985 79.3694 34.5641 77.9987 33.7272C76.6299 32.8914 75.0394 32.4915 73.4382 32.5804C72.6015 32.6026 71.7839 32.8349 71.0605 33.2559C70.1134 33.7862 69.1971 34.3699 68.3163 35.0043L68.3032 35.0137L68.2907 35.024C68.1657 35.1269 68.0102 35.1853 67.8485 35.1901C67.7704 35.1908 67.6939 35.168 67.6288 35.1246C67.563 35.0808 67.5122 35.0181 67.4829 34.9447L67.4607 34.8892L67.4261 34.8404L61.9309 27.1072C61.8617 27.0013 61.8259 26.8768 61.8285 26.75L61.8287 26.7365L61.8283 26.723C61.8247 26.6178 61.8428 26.5129 61.8814 26.4148C61.9182 26.3213 61.9728 26.236 62.0423 26.1636L76.8617 13.1817C76.9807 13.0831 77.0719 12.9553 77.1265 12.811C77.1826 12.6628 77.1983 12.5021 77.1713 12.3454L77.1689 12.3314L77.1657 12.3176C77.1207 12.1225 77.0026 11.955 76.8206 11.8516C76.6599 11.7602 76.4867 11.74 76.3486 11.74H54.4185V11.74L54.4106 11.7401C54.3321 11.7413 54.2542 11.7264 54.1818 11.6962C54.1094 11.6659 54.044 11.621 53.9897 11.5643L53.9814 11.5556L53.9727 11.5474C53.9162 11.4938 53.8716 11.429 53.8416 11.3571C53.8116 11.2853 53.7969 11.208 53.7984 11.1301L53.7985 11.1301V11.12V2.12004H53.7986L53.7985 2.11552C53.7978 2.03445 53.8132 1.95409 53.8439 1.87911C53.8745 1.80416 53.9198 1.73601 53.9772 1.67867C54.0345 1.62133 54.1027 1.57602 54.1776 1.54537C54.2526 1.51471 54.3329 1.49929 54.414 1.50003L54.414 1.50005H54.4185L93.3386 1.50007L93.3431 1.50003C93.4242 1.49929 93.5045 1.51471 93.5795 1.54537C93.6545 1.57602 93.7226 1.62133 93.78 1.67867C93.8371 1.73585 93.8824 1.80394 93.9131 1.87911C93.9439 1.95434 93.9593 2.03472 93.9586 2.11552V2.12004V12.372C93.9517 12.5671 93.9053 12.7589 93.822 12.9355C93.7377 13.1142 93.6175 13.2737 93.4689 13.4041L93.4688 13.404L93.4607 13.4114L81.2525 24.6006C81.1342 24.6981 81.0433 24.8248 80.989 24.9684C80.9318 25.1195 80.9173 25.2835 80.9472 25.4424Z"
                        />
                    </svg>
                </div>
            </a>
        </section>

        <div data-v-fae5bece="" data-inview="fadeInUp" data-delay="200" class="cta_wrap with-spacer is-in-view">
            <a data-v-fae5bece="" href="/services" class="cta" v-if="$route.meta.lang === 'fr'">
                <p data-v-fae5bece="" class="regular-text">Voir tous nos services</p><img data-v-fae5bece="" src="/static/img/arrow-right.86e3138c.svg" alt="arrow right">
            </a>
            <a data-v-fae5bece="" href="/en/services" class="cta" v-else>
                <p data-v-fae5bece="" class="regular-text">
                    See all our services
                </p>
                <img data-v-fae5bece="" src="/static/img/arrow-right.86e3138c.svg" alt="arrow right">
            </a>
        </div>

        <section class="project_listing" v-if="pageIsLoaded">
            <div class="title_wrap">
                <h2 class="title home small" data-inview="fadeInUp" data-delay="200">
                    {{ content.entete2.titre }}
                </h2>
                <h3 class="title home medium" data-inview="fadeInUp" data-delay="300">
                    <span v-html="content.entete2.texte"></span>
                </h3>
            </div>
            <div class="row">
                <router-link
                    :to="item.page.jsonUrl"
                    class="project"
                    data-inview="fadeInUp"
                    :data-delay="2 * 1 + '00'"
                    v-for="(item, i) in realisationsChunks[0]"
                    :key="i"
                >
                    <div class="img">
                        <div class="more">
                            <p class="regular-text">{{ $t('En savoir plus') }}</p>
                        </div>
                        <img
                            :src="item.page.imageSimple1.url"
                            :alt="item.page.imageSimple1.titre"
                            loading="lazy" width="659" height="553"
                        />
                    </div>
                    <div class="data">
                        <p class="title">{{ item.page.titre }}</p>
                    </div>
                </router-link>
            </div>
            <div class="row">
                <router-link
                    :to="item.page.jsonUrl"
                    class="project"
                    data-inview="fadeInUp"
                    :data-delay="2 * 1 + '00'"
                    v-for="(item, i) in realisationsChunks[1]"
                    :key="i"
                >
                    <div class="img">
                        <div class="more">
                            <p class="regular-text">{{ $t('En savoir plus') }}</p>
                        </div>
                        <img
                            :src="item.page.imageSimple1.url"
                            :alt="item.page.imageSimple1.titre"
                            loading="lazy" width="659" height="553"
                        />
                    </div>
                    <div class="data">
                        <p class="title">{{ item.page.titre }}</p>
                    </div>
                </router-link>
            </div>
            <div class="cta_wrap" data-inview="fadeInUp" data-delay="200">
                <router-link :to="{ name: 'Realisations-' + $route.meta.lang }" class="cta">
                    <p class="regular-text">{{ $t('Découvrez nos réalisations') }}</p>
                    <img src="@/assets/img/arrow-right.svg" alt="arrow right" />
                </router-link>
            </div>
        </section>

        <section class="about_home flip" v-if="pageIsLoaded">
            <div class="wrap">
                <div class="data">
                    <h2 class="title small" data-inview="fadeInUp" data-delay="200">
                        {{ content.split1.surtitre }}
                    </h2>
                    <h3 class="title medium" data-inview="fadeInUp" data-delay="300">
                        <span v-html="content.split1.titre"></span>
                    </h3>
                    <p class="regular-text" data-inview="fadeInUp" data-delay="400">
                        <span v-html="content.split1.texte"></span>
                    </p>
                    <a
                        :href="content.split1.boutonUrl[$route.meta.lang]"
                        class="cta"
                        data-inview="fadeInUp"
                        data-delay="500"
                    >
                        <p class="regular-text">{{ content.split1.bouton.customText }}</p>
                        <img src="@/assets/img/arrow-right-dark.svg" alt="arrow right" />
                    </a>
                </div>
            </div>
            <div class="img">
                <img class="content-img" :src="content.split1.image.url" :alt="content.split1.image.titre" loading="lazy" width="575" height="674" />
            </div>
        </section>

        <section class="career_wrap" v-if="pageIsLoaded">
            <div class="title_wrap" data-inview="fadeInUp" data-delay="200">
                <div class="left">
                    <h2 class="title small">{{ content.entete3.surtitre }}</h2>
                    <h3 class="title medium"><span v-html="content.entete3.titre"></span></h3>
                </div>
                <div class="right">
                    <p class="regular-text">
                        <span v-html="content.entete3.texte"></span>
                    </p>
                </div>
            </div>
            <div class="img_wrap" data-inview="fadeInUp" data-delay="300">
                <div class="row">
                    <img :src="content.images[0].url" :alt="content.images[0].titre" loading="lazy" width="665" height="746" />
                </div>
                <div class="row small">
                    <img :src="content.images[1].url" :alt="content.images[1].titre" loading="lazy" width="508" height="357" />
                    <a :href="'https://jobs.glowinthecloud.com/st-denis-thompson?l=' + $route.meta.lang" class="img_link">
                        <div class="link_txt">
                            <p class="regular-text">{{ $t('Découvrez nos postes') }}</p>
                            <svg
                                class="arrow"
                                viewBox="0 0 7 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M7 8L4.76837e-07 -3.0598e-07L-2.22545e-07 16L7 8Z" />
                            </svg>
                        </div>
                        <div class="overlay"></div>
                        <img :src="content.images[2].url" :alt="content.images[2].titre" loading="lazy" width="508" height="357" />
                    </a>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import GLightbox from 'glightbox'
// import Flickity from 'flickity'

export default {
    data() {
        return {
            lightboxelement: null,
        }
    },

    watch: {
        pageIsLoaded: {
            handler(pageIsLoaded) {
                if (pageIsLoaded) {
                    // Page loaded with Data
                    setTimeout(() => {
                        this.lightboxelement = GLightbox
                        GLightbox()

                        setTimeout(() => {
                            // this.teamCarousel.resize()
                            const videoRef = this.$refs.videoRef
                            const videoSrc = videoRef.getAttribute('data-src')
                            videoRef.setAttribute('src', videoSrc)
                            videoRef.classList.add('loaded')
                        }, 1755)
                    }, 1055)
                }
            },
            immediate: true,
        },
    },

    computed: {
        realisationsChunks() {
            if (!this.pageIsLoaded) {
                return [[], []]
            }
            // Take 4 items from realisationsEntry data array
            const realisationsArray = this.globals.realisationsEntry.data.slice(0, 4)
            // Split the realisations array in two chunks of 2
            return realisationsArray.reduce((acc, item, index) => {
                if (index % 2 === 0) {
                    acc.push([item])
                } else {
                    acc[acc.length - 1].push(item)
                }
                return acc
            }, [])
        },
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
}
</script>

<style lang="scss" scoped>

</style>
